import type { CPU } from '../CPU';
import { PSW_C, PSW_Z, PSW_MIE, H_TI } from './constants';
import { add8, zsCheck } from './arithmetic';

export function opNOP(_cpu: CPU): void {
}

export function opHALT(_cpu: CPU): void {
}

export function opCLRC(cpu: CPU): void {
  cpu.regs.psw &= ~PSW_C;
}

export function opSETC(cpu: CPU): void {
  cpu.regs.psw |= PSW_C;
}

export function opEI(cpu: CPU): void {
  cpu.regs.psw |= PSW_MIE;
}

export function opDI(cpu: CPU): void {
  cpu.regs.psw &= ~PSW_MIE;
}

export function opCPLC(cpu: CPU): void {
  cpu.regs.psw ^= PSW_C;
}

export function opADDSP(cpu: CPU): void {
  let val = cpu.impl_operands[0].value;
  val |= (val & 0x80) ? 0xFF00 : 0;
  cpu.regs.sp = (cpu.regs.sp + val) & 0xFFFE;
}

export function opLEA(cpu: CPU): void {
  cpu.regs.ea = 0;
  if (cpu.impl_operands[1].register_size)
    cpu.regs.ea += cpu.impl_operands[1].value;
  if (cpu.impl_hint & H_TI)
    cpu.regs.ea += cpu.impl_long_imm;
}

export function opINC_EA(cpu: CPU): void {
  cpu.impl_operands[0].value = cpu.mmu.read8(((cpu.regs.dsr << 16) | cpu.regs.ea) >>> 0);
  cpu.impl_operands[1].value = 1;
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  add8(cpu);
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
  cpu.impl_flags_changed &= ~PSW_C;
  cpu.mmu.write8(((cpu.regs.dsr << 16) | cpu.regs.ea) >>> 0, cpu.impl_operands[0].value);
}

export function opDEC_EA(cpu: CPU): void {
  cpu.impl_operands[0].value = cpu.mmu.read8(((cpu.regs.dsr << 16) | cpu.regs.ea) >>> 0);
  cpu.impl_operands[1].value = 1;
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  cpu.impl_operands[0].value ^= 0xFF;
  add8(cpu);
  cpu.impl_operands[0].value ^= 0xFF;
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
  cpu.impl_flags_changed &= ~PSW_C;
  cpu.mmu.write8(((cpu.regs.dsr << 16) | cpu.regs.ea) >>> 0, cpu.impl_operands[0].value);
}
